import { clinicalApiPath, viperApi } from '@/services/viper-api'

export const orgTrialFavoriteService = {
  basePath: (organizationId, userId) =>
    `${clinicalApiPath}/organizations/${organizationId}/organizationTrialFavorite`,

  get(organizationId) {
    return viperApi.get(this.basePath(organizationId))
  },

  setFavorited(orgId, orgTrialId, favorited) {
    return viperApi.put(`${this.basePath(orgId)}/${orgTrialId}`, JSON.stringify(!!favorited))
  },

  setFavoritedForParentTrial(request) {
    return viperApi.put(`${this.basePath(request.organizationId)}/parent-trial`, request)
  }
}
